import PropTypes from "prop-types"
import { forwardRef } from "react"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR } from "helpers/application"
import { cn } from "styles/utils"

const NavIcon = forwardRef(({ className, ...props }, ref) => (
  <FontAwesomeIcon
    className={cn(
      IS_JEWLR()
        ? "text-black-print tablet:text-24 text-18"
        : "text-20 text-black",
      className
    )}
    ref={ref}
    {...props}
  />
))

NavIcon.displayName = "NavIcon"

NavIcon.propTypes = {
  className: PropTypes.string,
}

export default NavIcon
